(function (_) {
    'use strict';

    _['POINTS.KEY'] = 'Programa de puntos';
    _['POINTS.EMPTY-LIST'] = 'No hay programas de puntos activos en este momento.';
    _['POINTS.VALID-FROM'] = 'Desde: ';
    _['POINTS.VALID-UNTIL'] = 'Hasta: ';
    _['POINTS.NO-LIMIT'] = 'Sin límite';
    _['POINTS.CONDITIONS'] = 'Condiciones';
    _['POINTS.CANCEL'] = 'Cancelar';
    _['POINTS.ACCEPT'] = 'Aceptar';
    _['POINTS.ASSIGN'] = 'Asignar';
    _['POINTS.REDEEM'] = 'Canjear';
    _['POINTS.EXCEPTIONS-TITLE'] = 'Excepciones';
    _['POINTS.PERIOD-VALIDITY'] = 'Periodo de validez';
    _['POINTS.DAILY-LIMIT'] = 'Has superado el límite diario.';
    _['POINTS.VALID-CODE'] = 'Codigo válido';
    _['POINTS.INVALID-CODE'] = 'Codigo inválido';
    _['POINTS.GIFT-FREEBIENAME'] = '¡Enhorabuena! Tienes gratis un:';
    _['POINTS.CODE-SHOW'] = 'Enseña este código QR para que se te asignen los puntos';
    _['POINTS.CODE-REDEEM'] = 'Enseña este código QR para canjear el premio';
    _['POINTS.POINTS-NOW'] = 'Now, your total points are:';
    _['POINTS.POINTS-EARNED'] = 'You just got';

}(translations['en']));



// WEBPACK FOOTER //
// ./src/app/modules/points/lang/points-lang_en.js